import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramNode } from '../../../common/models/care-monitor/program-node';
import { MatRadioModule } from '@angular/material/radio';
import { ProgramAnswer } from '../../../common/models/care-monitor/program-answer';
import { ProgramLog } from '@meplis/common';
import { Common } from '@meplis/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mec-program-matrix-radio',
  imports: [CommonModule, MatRadioModule],
  templateUrl: './program-matrix-radio.component.html',
  styleUrls: ['./program-matrix-radio.component.scss'],
})
export class ProgramMatrixRadioComponent implements OnDestroy {
  @Input() public nodes: ProgramNode[] = [];

  @Output() public onSelectItemChange = new EventEmitter<{
    questionIndex: number;
    programLog: ProgramLog;
    valid: boolean;
  }>();

  public selectedByNode: Record<string, string> = {};
  public headerColumns: { value: string; label: string }[] = [];

  public isMobile: boolean;

  public subscription: Subscription;

  constructor(private _commonService: Common) {
    this.isMobile = this._commonService.isMobile;

    this.subscription = this._commonService.isMobileChangeObservable().subscribe((isMobile) => {
      this.isMobile = this._commonService.isMobile;
    });
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['nodes']) {
      const map = new Map<string, string>();
      if (this.nodes && this.nodes.length) {
        for (const v of this.nodes[0].values || []) {
          const val = String(v.value);
          map.set(val, v.label || v.name || val);
        }
        for (const node of this.nodes) {
          for (const v of node.values || []) {
            const val = String(v.value);
            if (!map.has(val)) {
              map.set(val, v.label || v.name || val);
            }
          }
        }
      }
      this.headerColumns = Array.from(map.entries()).map(([value, label]) => ({
        value,
        label,
      }));

      this.selectedByNode = {};
      for (const node of this.nodes || []) {
        const name = node.variable?.name ?? node.id;
        const existing = (node.log?.results || []).find((r) => r.name === name);
        this.selectedByNode[node.id] = existing ? String(existing.value) : '';
      }
    }
  }

  public isOptionAvailableForNode(
    node: ProgramNode,
    optionValue: string
  ): boolean {
    return !!(node?.values || []).find(
      (v) => String(v.value) === String(optionValue)
    );
  }

  public selectItem(node: ProgramNode, value: string): void {
    const name = node.variable?.name ?? node.id;

    this.selectedByNode[node.id] = String(value);

    const programAnswer: ProgramAnswer = {
      name,
      value,
    };

    const programLog: ProgramLog = {
      to: node.id,
      at: new Date().toISOString(),
      results: [programAnswer],
    };

    const questionIndex = this.nodes.indexOf(node);

    this.onSelectItemChange.emit({
      questionIndex,
      programLog,
      valid: true,
    });
  }
}
